<template>
  <div class="col-md-12" style="padding-top: 20px;">
    <checkbox
  ref="input"
  :readonly="readonly"
  :name="name"

  :true-value="1"
  :false-value="0"

  v-model="numericModel"

  data-vv-as="Optin"
  :data-vv-name="name"
  data-vv-validate-on="input"

  v-validate="'required|optin'"
>
  <span v-html="finalLabelText"></span>
</checkbox>

    <span class="text-danger" v-if="errors.has(name)">
        {{ errors.first(name) }}
    </span>
  </div>
</template>
<script>
export default {
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator"],
  name: "c-optin",
  props: {
    label: String,
    name: {
      required: true,
      type: String
    },
    textoAjuda: {
      type: String,
      default: null
    },
    disabled: Boolean,
    readonly: Boolean,
    value: {
      type: [Boolean, Number],
      default: 0
    },
    required: Boolean
  },
  computed: {
    isNumericValue() {
      // O operador unário '+' converte true/false para 1/0
      return +this.value;
    },
    finalLabelText() {
      return this.textoAjuda && this.textoAjuda.trim() !== ""
        ? this.textoAjuda
        : "Concordo em receber mensagens pelo WhatsApp e estou ciente que meu responsável financeiro receberá informações sobre assuntos financeiros.";
    },
    numericModel: {
      get() {
        return +this.value; // garante 0 ou 1
      },
      set(val) {
        this.$emit("input", +val);
        this.$validator.validate(this.name);
      }
    }

  },
  created() {
    this.$validator.extend("optin", {
      getMessage: field => `O campo ${field} precisa ser marcado.`,
      validate: value => {
        return String(value) === "1";
      }
    });
  },
  methods: {
    handleInput(value) {
      const numericValue = +value;
      this.$emit("input", numericValue);
      this.$validator.validate(this.name);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Crm/Optin.vue